<template>
  <a-modal v-model="visible" v-if="visible" :title="title" width="1300px" destroyOnClose cancelText="取消" okText="确定"
    @cancel="cancel" @ok="exportExcel">
    <a-row justify="space-between" type="flex" style="margin-bottom:10px" v-if="reportKey === 1">
      <div>
        <span style="padding-right: 5px;">价格来源：</span>
        <a-radio-group v-model="priceSource" @change="getList">
          <a-radio v-for="item in priceOption" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-radio>
        </a-radio-group>
      </div>
    </a-row>
    <RawUseTable v-if="rTableKeys.includes(reportKey)" :ArrLen="arrLen(reportKey)" :list="list" />
    <AssessTable v-if="reportKey === 4" :list="list" :tableLoading="tableLoading" />
    <a-row slot="footer" justify="space-between" type="flex">
      <a-button @click="cancel">关闭</a-button>
      <a-button type="primary" @click="exportExcel">导出</a-button>
    </a-row>
    <ReportConfirm :priceSource="priceSource" />
  </a-modal>
</template>

<script>
import { formulaMixins } from '../unitls';
import AssessTable from '../ReportComponents/AssessTable';
import RawUseTable from '../ReportComponents/RawUseTable';
import ReportConfirm from './ReportConfirm.vue';
export default {
  components: { RawUseTable, AssessTable, ReportConfirm },
  mixins: [formulaMixins],
  data() {
    return {
      priceOption: [
        { label: "市场价格", value: '4' },
        { label: "库存价格", value: '3' },
        { label: "合同价格", value: '1' },
        { label: "预测价格", value: '2' },
      ],
      priceSource: 4,
      list: [],
      tableLoading: false,
      rTableKeys: [0, 1, 2, 3, 5],
    };
  },
  computed: {
    title() {
      return this.reportTypes[this.reportKey];
    },
    visible: {
      get() {
        return this.reportVisible;
      },
      set() { }
    },
  },
  mounted() { },
  watch: {
    reportVisible(val) {
      if (val) {
        this.list = [];
        this.priceSource = this.detail.priceSource;
        this.getList();
      }
    },
  },
  methods: {
    arrLen(reportKey) {
      let num = 6;
      if (reportKey === 1) num = 11;
      if (reportKey === 5) num = 7;
      return num;
    },
    exportExcel() {
      this.toggleVisible('reportConfirmVisible');
    },
    cancel() {
      this.setState({ reportVisible: false });
    },
    async getList() {
      let urlObj = {
        0: '/nhf-app/formulaspeedtask/getSpeedRawUseContrastList',
        1: '/nhf-app/formulaspeedtask/getSpeedFormulaCostContrastList',
        2: '/nhf-app/formulaspeedtask/getSpeedRawUseContrastList',
        3: '/nhf-app/formulaspeedtask/getSpeedRawWeightContrastList',
        4: '/nhf-app/formulataskformularaw/selectSpeedTaskFormulaRawAssessPage',
        5: '/nhf-app/formulaspeedtask/getSpeedFormulaTaskRawContrastList',
      };
      // let urlObj = {
      //   0: '/nhf-app/formulaspeedtask/getSpeedRawUseContrastList',
      //   1: '/nhf-app/formulaspeedtask/getSpeedFormulaTaskRawContrastList',
      // };
      let params = {
        taskId: this.taskId,
        priceSource: this.priceSource,
        current: 1,
        size: 1000,
      };
      if (this.reportKey === 0) {
        params.isFilterDiff = 1;
      }

      if (this.reportKey === 2) {
        params.isFilterDiff = 0;
      }
      if (this.reportKey === 4) {
        params.factoryId = window.localStorage.getItem('factoryId');
      }
      let res = await this.$http.get(urlObj[this.reportKey], { params });
      let { success, msg, data } = res || {};
      if (this.rTableKeys.includes(this.reportKey)) {
        let lst = [];
        data.forEach(el => {
          let obj = {};
          el && el.forEach((item, index) => {
            obj[`v${index + 1}`] = item;
          });
          let arrLen = el.length;
          let isDeleted = obj[`v${arrLen - 2}`],
            isRawDelete = obj[`v${arrLen - 1}`],
            isExtraProRaw = obj[`v${arrLen}`];

          let f1 = !(isRawDelete == 0 && isDeleted == 1 && isExtraProRaw == 0);
          let f2 = !(isRawDelete == 1 && isDeleted == 1 && isExtraProRaw == 0);
          // if(isDeleted != 1 || (isRawDelete == 1 || isExtraProRaw == 1) || obj.v1 == '合计') lst.push(obj)
          if ((f1 && f2) || obj.v1 == '合计') lst.push(obj);
          // lst.push(obj)
        });
        this.list = lst || [];
      } else if (this.reportKey === 4) {
        if (data) {
          data = data.filter(el => el.isDeleted !== 1 || (el.isRawDelete === 1 || el.isExtraProRaw === 1));
        }
        this.list = data || [];
      }
      this.$message[success ? 'success' : 'warning'](msg);
    },
  }
};
</script>
